import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
// import lottie from "vue-lottie";
import Vant from 'vant';
import 'vant/lib/index.css';
import Axios from 'axios'
import  {VueJsonp}  from  'vue-jsonp'
import TlbsMapVue from 'tlbs-map-vue'
Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

Vue.prototype.$api = Axios


Vue.use(VueJsonp);
Vue.use(Vant);
Vue.use(TlbsMapVue, {
  key: 'TOWBZ-VKCK3-WDJ33-RSQE6-Z65I6-5VBXF'
});
Vue.config.productionTip = false

// 抑制 tlbs-map-vue 在 Vue 2 中的兼容性警告
const originalWarn = Vue.config.warnHandler
Vue.config.warnHandler = function(msg, vm, trace) {
  // 忽略 onUnmounted 相关的警告（tlbs-map-vue 在 Vue 2 中的兼容性问题）
  if (msg && msg.includes('onUnmounted is called when there is no active component instance')) {
    return
  }
  // 其他警告正常显示
  if (originalWarn) {
    originalWarn.call(null, msg, vm, trace)
  } else {
    console.warn(msg, trace)
  }
}
// Vue.component("lottie", lottie);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
